import React from "react";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

function CajaSimple(props) {
    return (

            <div className="caja-vacia">
                <h2 className={"encabezado"}>{props.encabezado}</h2>
                <p className={"descripcion"} >{props.descripcion}</p>

            </div>


    );
}

export default CajaSimple;